import { AuthService } from 'src/app/_services/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dream',
  templateUrl: './dream.component.html',
  styleUrls: ['./dream.component.css']
})
export class DreamComponent implements OnInit {
  myImage=""
  constructor( 
    public authService:AuthService
  ) {
    this.myImage=this.dreamImage()
   }

  ngOnInit(): void {
   
  }

  dreamImage(){
    let x= Math.floor(Math.random() * Math.floor(1000));
		let imageId= (x%5 +1)
    return `/assets/images/dreams/d${imageId}.png`;
  }
}
